module.exports = new __parcel__URL__("hud_build_button.a0bfb0fe.png").toString();